import { useState } from 'react';
import styles from './styles.module.scss';
import cn from 'classnames';

function CategoryRow({ category, enabled, onToggle, isRequired }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={styles.category}>
            <div className={styles.category__header}>
                <button
                    className={styles.category__toggle}
                    onClick={() => setExpanded(v => !v)}
                    aria-expanded={expanded}
                    aria-label={`${expanded ? 'Collapse' : 'Expand'} ${category.label}`}
                >
                    <span className={cn(styles.category__arrow, { [styles['category__arrow--open']]: expanded })}>›</span>
                    <span className={styles.category__label}>{category.label}</span>
                </button>

                {isRequired ? (
                    <span className={styles.category__active}>ACTIVE</span>
                ) : (
                    <div className={styles.category__switches}>
                        <button
                            type="button"
                            className={cn(styles.switchBtn, { [styles['switchBtn--active']]: !enabled })}
                            onClick={() => onToggle(false)}
                            aria-pressed={!enabled}
                            aria-label={`Disable ${category.label}`}
                        >
                            NO
                        </button>
                        <button
                            type="button"
                            className={cn(styles.switchBtn, styles['switchBtn--yes'], { [styles['switchBtn--active']]: enabled })}
                            onClick={() => onToggle(true)}
                            aria-pressed={enabled}
                            aria-label={`Enable ${category.label}`}
                        >
                            YES
                        </button>
                    </div>
                )}
            </div>

            {expanded && category.description && (
                <p className={styles.category__description}>{category.description}</p>
            )}
        </div>
    );
}

export default function PrivacyPreferenceCentre({ categories, preferences, onSave, onAcceptAll, onClose }) {
    const [localPrefs, setLocalPrefs] = useState({ ...preferences });

    const toggle = (key, value) => setLocalPrefs(prev => ({ ...prev, [key]: value }));

    return (
        <div className={styles.prefCentre} role="dialog" aria-modal="true" aria-label="Privacy Preference Centre">
            <div className={styles.prefCentre__inner}>
                <button className={styles.prefCentre__close} onClick={onClose} aria-label="Close">×</button>

                <h4 className={styles.prefCentre__title}>Privacy preference centre</h4>

                <p className={styles.prefCentre__intro}>
                    When you visit any website, it may store or retrieve information on your browser, mostly in the
                    form of cookies. This information might be about you, your preferences or your device and is mostly
                    used to provide you with a good experience. You can choose not to allow some types of cookies. Click
                    on the different category headings to find out more and change our default settings. However,
                    blocking some types of cookies may impact your experience of the site.
                </p>

                <div className={styles.categories}>
                    <CategoryRow
                        category={{ key: 'required', label: 'Required Cookies', description: 'These cookies are essential for the website to function and cannot be disabled.' }}
                        enabled={true}
                        isRequired={true}
                    />
                    {categories.map(cat => (
                        <CategoryRow
                            key={cat.key}
                            category={cat}
                            enabled={!!localPrefs[cat.key]}
                            onToggle={val => toggle(cat.key, val)}
                            isRequired={false}
                        />
                    ))}
                </div>

                <div className={styles.prefCentre__buttons}>
                    <button className={cn(styles.btn, styles['btn__submit'])} onClick={() => onSave(localPrefs)}>
                        Submit preferences
                    </button>
                    <button className={cn(styles.btn, styles['btn__accept'])} onClick={onAcceptAll}>
                        Accept all
                    </button>
                </div>
            </div>
        </div>
    );
}
